import { makeStyles } from "@material-ui/core";

export const css = makeStyles((theme) => ({
    instructions_card: {
        padding: "16px",
        margin: "16px 0",
    },
    title: {
        height: "48px",
        color: theme.palette.primary.main,
    },
}));
